import { createAsyncGetters } from '@play-co/replicant';
import { stateSchema } from './State';
import computedProperties from './computedProperties';
import { Visit } from './visit';
import { Pet } from './buruburu/pet';
import { Duo } from './duo';
import { FBClient } from './utils/fb';

export interface InstagramProfile {
  name?: string
  photoUrl?: string
  username?: string
  isFollowing?: boolean
}

export interface MessengerProfile {
  name?: string
  photoUrl?: string
  fullName?: string
  gender?: string
}

export const asyncGetters = createAsyncGetters(stateSchema, {
  computedProperties,
})({
  ...Visit.asyncGetters,
  ...Pet.asyncGetters,
  ...Duo.asyncGetters,

  async getInstagramProfile (_: void, api): Promise<InstagramProfile> {
    const state = await api.getOwnState();
    if (!state.instagramId) {
      throw new Error('No Instagram account for this player');
    }

    const fb = new FBClient(process.env['INSTAGRAM_PAGE_ACCESS_TOKEN']);
    const res = await fb.get(`${state.instagramId}?fields=name,profile_pic,username,is_user_follow_business`);

    return {
      name: res['short_name'],
      username: res['username'],
      photoUrl: res['profile_pic'],
      isFollowing: res['is_user_follow_business'],
    };
  },

  async getMessengerProfile (_: void, api): Promise<MessengerProfile> {
    const state = await api.getOwnState();
    if (!state.messengerId) {
      throw new Error('No Messenger account for this player');
    }

    const fb = new FBClient(process.env['FB_PAGE_ACCESS_TOKEN']);
    const res = await fb.get(`${state.messengerId}?fields=short_name,name,gender,profile_pic`);

    return {
      name: res['short_name'],
      fullName: res['name'],
      gender: res['gender'],
      photoUrl: res['profile_pic'],
    };
  }
});
